import styled from 'styled-components';

export const ScreenReaderOnly = styled.span`
    position: absolute;
    height: 1px;
    width: 1px;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
`;
